export enum OperatorComparison {
  BETWEEN,
  LESS_THAN,
  GREATER_THAN,
  EQUALS,
}

export namespace OperatorComparison {
  let elements = [
    OperatorComparison.BETWEEN,
    OperatorComparison.LESS_THAN,
    OperatorComparison.GREATER_THAN,
    OperatorComparison.EQUALS,
  ];
  let alias = "com.bcdfx.model.OperatorComparison";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
